/**
 * The Orbit Sync mark: a core, an inclined orbit, and a satellite on it.
 *
 * Drawn with `currentColor` so it takes the brand colour from CSS rather than
 * baking one in, which is what lets the same component sit on the header, the
 * auth panel and the favicon-adjacent surfaces without a second asset.
 */
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* The two peers. */}
      <circle cx="16" cy="16" r="5.5" fill="currentColor" />
      <circle cx="16" cy="16" r="2.25" fill="var(--surface, #13161e)" />

      {/* The link between them: one orbit, inclined. */}
      <ellipse
        cx="16"
        cy="16"
        rx="14"
        ry="6.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
        transform="rotate(-34 16 16)"
      />

      {/* The satellite, parked on the orbit path. */}
      <circle cx="26.2" cy="9.4" r="2.75" fill="currentColor" />
    </svg>
  );
}

interface LogoProps {
  size?: number;
  /** Hide the wordmark and render the mark alone. */
  markOnly?: boolean;
}

export function Logo({ size = 24, markOnly = false }: LogoProps) {
  return (
    <>
      <LogoMark size={size} />
      {markOnly ? null : (
        <span className="brand-word">
          Orbit&nbsp;<em>Sync</em>
        </span>
      )}
    </>
  );
}
